"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._62To10 = exports._36To10 = exports._32To10 = exports._16To10 = exports._8To10 = exports._2To10 = exports._10To62 = exports._10To36 = exports._10To32 = exports._10To16 = exports._10To8 = exports._10To2 = exports.convertBase = void 0;
var decimal_js_1 = __importDefault(require("decimal.js"));
decimal_js_1.default.set({ precision: 1e9 });
decimal_js_1.default.set({ toExpPos: 9e15 });
var _convertFromDecimal = function (num, base) {
    var convertedNumArr = [];
    var decimalNum = new decimal_js_1.default(num);
    var decimalBase = new decimal_js_1.default(base.length);
    while (!decimalNum.isZero()) {
        var remainder = decimalNum.mod(decimalBase).toNumber();
        decimalNum = decimalNum.dividedToIntegerBy(decimalBase);
        convertedNumArr.unshift(base.substr(remainder, 1));
    }
    if (convertedNumArr.length === 0) {
        convertedNumArr.unshift("0");
    }
    return convertedNumArr.join("");
};
var _convertToDecimal = function (num, base) {
    var baseChar2Idx = {};
    for (var i = 0; i < base.length; i++) {
        baseChar2Idx[base.substr(i, 1)] = new decimal_js_1.default(i);
    }
    var decimalBase = new decimal_js_1.default(base.length);
    var convertedNum = new decimal_js_1.default(0);
    for (var i = 0; i < num.length; i++) {
        var tmpDecimal1 = baseChar2Idx[num.substr((i + 1) * -1, 1)];
        var tmpDecimal2 = decimal_js_1.default.pow(decimalBase, i);
        var tmpDecimal3 = tmpDecimal1.times(tmpDecimal2);
        convertedNum = convertedNum.plus(tmpDecimal3);
    }
    return convertedNum.toString();
};
/**
 * Convert num from originalBase to newBase.
 */
var convertBase = function (num, originalBase, newBase) {
    var BASE62 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if ((typeof num !== "number" && typeof num !== "string") ||
        (typeof num === "number" && !isFinite(num))) {
        throw new Error("First augument must be a number or string.");
    }
    if (typeof num === "number") {
        num = num.toString();
    }
    if (typeof originalBase !== "number" && typeof originalBase !== "string") {
        throw new Error("Second augument must be a number or string.");
    }
    if (typeof originalBase === "number") {
        if (!Number.isInteger(originalBase)) {
            throw new Error("Second augument must be integer.");
        }
        if (!(2 <= originalBase && originalBase <= 62)) {
            throw new Error("Second augument must be between 2 and 62.");
        }
        originalBase = BASE62.substr(0, originalBase);
    }
    if (originalBase.length <= 1) {
        throw new Error("Second augument' length must be larger than 1. Base 1 or smaller cannnot be defined.");
    }
    if (originalBase.length !== new Set(originalBase).size) {
        throw new Error("Second augument must not contain the same characters.");
    }
    var availableCharacters = new RegExp("^[" + originalBase + "]+$");
    if (!availableCharacters.test(num)) {
        throw new Error("First augument must consist of second augument.");
    }
    if (typeof newBase !== "number" && typeof newBase !== "string") {
        throw new Error("Third augument must be a number or string.");
    }
    if (typeof newBase === "number") {
        if (!Number.isInteger(newBase)) {
            throw new Error("Third augument must be integer.");
        }
        if (!(2 <= newBase && newBase <= 62)) {
            throw new Error("Third augument must be between 2 and 62.");
        }
        newBase = BASE62.substr(0, newBase);
    }
    if (newBase.length <= 1) {
        throw new Error("Third augument' length must be larger than 1. Base 1 or smaller cannnot be defined.");
    }
    if (newBase.length !== new Set(newBase).size) {
        throw new Error("Third augument must not contain the same characters.");
    }
    var tmpNum = _convertToDecimal(num, originalBase);
    return _convertFromDecimal(tmpNum, newBase);
};
exports.convertBase = convertBase;
var _10To2 = function (num) {
    return convertBase(num, 10, 2);
};
exports._10To2 = _10To2;
var _10To8 = function (num) {
    return convertBase(num, 10, 8);
};
exports._10To8 = _10To8;
var _10To16 = function (num) {
    return convertBase(num, 10, 16);
};
exports._10To16 = _10To16;
var _10To32 = function (num) {
    return convertBase(num, 10, 32);
};
exports._10To32 = _10To32;
var _10To36 = function (num) {
    return convertBase(num, 10, 36);
};
exports._10To36 = _10To36;
var _10To62 = function (num) {
    return convertBase(num, 10, 62);
};
exports._10To62 = _10To62;
var _2To10 = function (num) {
    return convertBase(num, 2, 10);
};
exports._2To10 = _2To10;
var _8To10 = function (num) {
    return convertBase(num, 8, 10);
};
exports._8To10 = _8To10;
var _16To10 = function (num) {
    return convertBase(num, 16, 10);
};
exports._16To10 = _16To10;
var _32To10 = function (num) {
    return convertBase(num, 32, 10);
};
exports._32To10 = _32To10;
var _36To10 = function (num) {
    return convertBase(num, 36, 10);
};
exports._36To10 = _36To10;
var _62To10 = function (num) {
    return convertBase(num, 62, 10);
};
exports._62To10 = _62To10;
